// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__3ZcYp","scrollToTop":"Footer_scrollToTop__2ajzt","floating":"Footer_floating__x_GXs"};